import { useEffect, useState } from "react";
import api from "../api/api";
import Select from "react-select";

export default function Packages() {
  const emptyForm = {
    contractor_id: "",
    quantity_plastic: "0",
    quantity_aluminium: "0",
    quantity_other: "0",
    remarks: ""
  };

  const [packages, setPackages] = useState([]);
  const [contractors, setContractors] = useState([]);
  const [form, setForm] = useState(emptyForm);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editId, setEditId] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [errors, setErrors] = useState({});
  const [backendError, setBackendError] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const [filters, setFilters] = useState({
    name: "",
    city: "",
    street: "",
    zip: "",
    quantity_plastic: "",
    quantity_aluminium: "",
    quantity_other: "",
    remarks: ""
  });

  const btn = {
    primary:
      "bg-blue-600 text-white text-sm font-semibold px-4 py-1.5 rounded hover:bg-blue-700 transition shadow-sm",
    success:
      "bg-green-600 text-white text-sm font-semibold px-4 py-1.5 rounded hover:bg-green-700 transition shadow-sm",
    danger:
      "bg-red-500 text-white text-sm font-semibold px-4 py-1.5 rounded hover:bg-red-600 transition shadow-sm",
    ghost:
      "bg-gray-200 text-gray-700 text-sm font-medium px-4 py-1.5 rounded hover:bg-gray-300 transition",
  };

  useEffect(() => {
    fetchPackages();
    fetchContractors();
  }, []);

  const fetchPackages = async () => {
    try {
      const res = await api.get("/packages");
      setPackages(res.data);
    } catch (err) {
      console.error("Błąd podczas pobierania rozliczeń:", err);
    }
  };

  const fetchContractors = async () => {
    try {
      const res = await api.get("/contractors");
      setContractors(res.data);
    } catch (err) {
      console.error("Błąd pobierania kontrahentów:", err);
    }
  };

  const openCreateModal = () => {
    setForm(emptyForm);
    setEditId(null);
    setErrors({});
    setBackendError("");
    setShowEditModal(true);
  };

  const openEditModal = (p) => {
    setForm({
      contractor_id: p.contractor_id,
      quantity_plastic: p.quantity_plastic,
      quantity_aluminium: p.quantity_aluminium,
      quantity_other: p.quantity_other,
      remarks: p.remarks,
    });
    setEditId(p.id);
    setErrors({});
    setBackendError("");
    setShowEditModal(true);
  };

  const closeEditModal = () => {
    setShowEditModal(false);
    setForm(emptyForm);
    setEditId(null);
    setErrors({});
    setBackendError("");
  };

  const validateForm = () => {
    const newErrors = {};
    if (!form.contractor_id) newErrors.contractor_id = "Wybierz kontrahenta";
    if (form.remarks && (form.remarks.length > 256))
      newErrors.remarks = "Uwagi nie mogą być dłuższe niż 256 znaków";
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});
    setBackendError("");
    console.log(form);

    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    try {
      if (editId) {
        await api.put(`/packages/${editId}`, form);
      } else {
        await api.post("/packages", form);
      }
      fetchPackages();
      closeEditModal();
    } catch (err) {
      console.error("Błąd zapisu rozliczenia:", err.response?.data || err.message);

      const backendData = err.response?.data;
      if (backendData && typeof backendData === "object") {
        const newFieldErrors = {};
        for (const key in backendData) newFieldErrors[key] = backendData[key];
        setErrors(newFieldErrors);
      } else {
        setBackendError(backendData?.detail || "Wystąpił nieoczekiwany błąd");
      }
    }
  };

  const handleDelete = async (id) => {
    if (!id) return false;
    setIsDeleting(true);
    try {
      await api.delete(`/packages/${id}`);
      fetchPackages();
      return true;
    } catch (err) {
      console.error("Błąd usuwania rozliczenia:", err);
      return false;
    } finally {
      setIsDeleting(false);
    }
  };

  const confirmDelete = async () => {
    await handleDelete(deleteId);
    setShowDeleteModal(false);
    setDeleteId(null);
  };

  const contractorOptions = contractors.map((c) => ({
    value: c.id,
    label: `${c.name} [${c.street}]`,
    contactPerson: c.contact_person,
    contractor: c,
  }));

const filteredPackages = packages.filter((p) => {
  const matchesName = (p.name || "")
    .toLowerCase()
    .includes(filters.name.toLowerCase());

  const matchesCity = (p.city || "")
    .toLowerCase()
    .includes(filters.city.toLowerCase());

  const matchesStreet = (p.street || "")
    .toLowerCase()
    .includes(filters.street.toLowerCase());

  const matchesZip = (p.zip_code || "")
    .toLowerCase()
    .includes(filters.zip.toLowerCase());

  const matchesQtyPlastic = String(p.quantity_plastic ?? "")
    .includes(filters.quantity_plastic);

  const matchesQtyAluminium = String(p.quantity_aluminium ?? "")
    .includes(filters.quantity_aluminium);

  const matchesQtyOther = String(p.quantity_other ?? "")
    .includes(filters.quantity_other);

  const matchesRemarks = (p.remarks || "")
    .toLowerCase()
    .includes(filters.remarks.toLowerCase());

  return (
    matchesName &&
    matchesCity &&
    matchesStreet &&
    matchesZip &&
    matchesQtyPlastic &&
    matchesQtyAluminium &&
    matchesQtyOther &&
    matchesRemarks
  );
});

  return (
    <div className="p-3 space-y-6">
      <div className="flex items-center justify-between">
        <button onClick={openCreateModal} className={btn.primary}>
          + Dodaj nowe rozliczenie
        </button>
      </div>

      <div className="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-xs">
            <thead className="bg-gray-100 text-gray-600">
              <tr className="text-left text-xs font-semibold">
                <th className="px-2 py-3 align-bottom">Nazwa</th>
                <th className="px-2 py-3 align-bottom">Miasto</th>
                <th className="px-2 py-3 align-bottom">Ulica</th>
                <th className="px-2 py-3 align-bottom">Kod</th>
                <th className="px-2 py-3 align-bottom">Plastikowe</th>
                <th className="px-2 py-3 align-bottom">Aluminiowe</th>
                <th className="px-2 py-3 align-bottom">Bezpieczne szafki</th>
                <th className="px-2 py-3 align-bottom">Uwagi</th>
                <th className="px-2 py-3 align-bottom text-center">Akcje</th>
              </tr>

              <tr className="bg-white text-xs border-t border-gray-200">
                {[
                  { key: "name", placeholder: "Nazwa...", type: "text" },
                  { key: "city", placeholder: "Miasto...", type: "text" },
                  { key: "street", placeholder: "Ulica...", type: "text" },
                  { key: "zip", placeholder: "Kod...", type: "text" },
                  { key: "quantity_plastic", placeholder: "Plastikowe...", type: "text" },
                  { key: "quantity_aluminium", placeholder: "Aluminiowe...", type: "text" },
                  { key: "quantity_other", placeholder: "Szafki...", type: "text" },
                  { key: "remarks", placeholder: "Uwagi...", type: "text" },
                ].map((f) => (
                  <th key={f.key} className="py-2 align-top">
                    <div className="px-2">
                      <input
                        type={f.type}
                        placeholder={f.placeholder}
                        value={filters[f.key]}
                        onChange={(e) =>
                          setFilters({ ...filters, [f.key]: e.target.value })
                        }
                        className="w-full h-8 border border-gray-200 rounded-md px-1 text-xs focus:outline-none focus:ring-1 focus:ring-blue-500"
                      />
                    </div>
                  </th>
                ))}

                <th />
              </tr>
            </thead>

            <tbody className="divide-y divide-gray-100">
              {filteredPackages.map((p) => {
                return (
                  <tr
                    key={p.id}
                    className="cursor-pointer transition-colors hover:bg-gray-50 bg-white text-xs"
                  >
                    <td className="px-2 py-3 font-medium text-gray-800">{p.name}</td>
                    <td className="px-2 py-3">{p.city}</td>
                    <td className="px-2 py-3">{p.street}</td>
                    <td className="px-2 py-3">{p.zip_code}</td>
                    <td className="px-2 py-3 text-center">{p.quantity_plastic}</td>
                    <td className="px-2 py-3 text-center">{p.quantity_aluminium}</td>
                    <td className="px-2 py-3 text-center">{p.quantity_other}</td>
                    <td className="px-2 py-3 text-center">{p.remarks}</td>

                    <td className="px-2 py-3 flex justify-center gap-2">
                      <button
                        onClick={() => openEditModal(p)}
                        className={btn.primary}
                      >
                        Edytuj
                      </button>
                      <button
                        onClick={() => {
                          setDeleteId(p.id);
                          setShowDeleteModal(true);
                        }}
                        className={btn.danger}
                      >
                        Usuń
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>


          {showEditModal && (
            <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">

              <div className="bg-white w-[750px] rounded-lg shadow-xl max-h-[90vh] flex flex-col overflow-hidden">

                <div className="px-6 py-4 border-b bg-gray-50">
                  <h2 className="text-xl font-bold text-gray-800">
                    {editId ? "Edytuj rozliczenie" : "Dodaj rozliczenie"}
                  </h2>

                  {backendError && (
                    <div className="mt-2 text-red-600 font-medium">
                      {backendError}
                    </div>
                  )}
                </div>

                <div className="p-6 overflow-y-auto">

                  <form onSubmit={handleSubmit} className="flex flex-col gap-3">

                    <div className="flex items-center gap-3">
                      <label className="w-40 font-medium text-gray-700">
                        Kontrahent
                      </label>

                      <div className="flex-1">
                        <Select
                          className="w-full"
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          styles={{
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 9999,
                            }),
                          }}
                          options={contractorOptions}
                          formatOptionLabel={(option) => (
                            <div>
                              <div>{option.label}</div>
                              <div className="text-xs text-gray-500">
                                {option.contactPerson}
                              </div>
                            </div>
                          )}
                          placeholder="Wybierz kontrahenta"
                          isSearchable
                          value={
                            contractorOptions.find(
                              (option) =>
                                String(option.value) === String(form.contractor_id)
                            ) || null
                          }
                          onChange={(selected) => {
                            setForm((prev) => ({
                              ...prev,
                              contractor_id: selected?.value || "",
                              remarks: selected?.contractor?.remarks || "",
                            }));
                          }}
                        />
                      </div>
                    </div>

                    {errors.contractor_id && (
                      <span className="text-red-500 text-sm ml-40">
                        {errors.contractor_id}
                      </span>
                    )}

                    <div className="flex items-center gap-3">
                      <label className="w-40 font-medium text-gray-700">
                        Pojemniki plastikowe
                      </label>

                      <input
                        type="number"
                        min={1}
                        className="flex-1 border p-2 rounded-md text-sm h-[38px] focus:outline-none focus:ring-2 focus:ring-blue-400"
                        value={form.quantity_plastic}
                        onChange={(e) =>
                          setForm({ ...form, quantity_plastic: e.target.value })
                        }
                      />
                    </div>

                    <div className="flex items-center gap-3">
                      <label className="w-40 font-medium text-gray-700">
                        Pojemniki aluminiowe
                      </label>

                      <input
                        type="number"
                        min={1}
                        className="flex-1 border p-2 rounded-md text-sm h-[38px] focus:outline-none focus:ring-2 focus:ring-blue-400"
                        value={form.quantity_aluminium}
                        onChange={(e) =>
                          setForm({ ...form, quantity_aluminium: e.target.value })
                        }
                      />
                    </div>

                    <div className="flex items-center gap-3">
                      <label className="w-40 font-medium text-gray-700">
                        Bezpieczne szafki
                      </label>

                      <input
                        type="number"
                        min={1}
                        className="flex-1 border p-2 rounded-md text-sm h-[38px] focus:outline-none focus:ring-2 focus:ring-blue-400"
                        value={form.quantity_other}
                        onChange={(e) =>
                          setForm({ ...form, quantity_other: e.target.value })
                        }
                      />
                    </div>


                    <div className="flex items-center gap-3">
                      <label className="w-40 font-medium text-gray-700">
                        Uwagi
                      </label>

                      <textarea
                        className={`flex-1 border p-2 rounded-md text-sm focus:outline-none focus:ring-2 ${errors.remarks
                          ? "border-red-500 focus:ring-red-400"
                          : "focus:ring-blue-400"
                          }`}
                        value={form.remarks}
                        onChange={(e) =>
                          setForm({ ...form, remarks: e.target.value })
                        }
                        maxLength={256}
                      />
                    </div>

                    {errors.remarks && (
                      <span className="text-red-500 text-sm ml-40">
                        {errors.remarks}
                      </span>
                    )}

                  </form>
                </div>

                <div className="px-6 py-4 border-t flex justify-end gap-3 bg-white">

                  <button
                    type="button"
                    onClick={closeEditModal}
                    className={btn.danger}
                  >
                    Anuluj
                  </button>

                  <button
                    onClick={handleSubmit}
                    className={btn.success}
                  >
                    Zapisz
                  </button>

                </div>

              </div>
            </div>
          )}

          {showDeleteModal && (
            <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
              <div className="bg-white p-6 w-[500px] rounded shadow-lg relative">
                <p className="mb-4">
                  Czy na pewno chcesz usunąć rozliczenie{" "}
                  <span className="font-bold text-red-600">{deleteId}</span>{" "}
                  i wszystkie powiązane z nim elementy?
                </p>

                <div className="flex justify-end gap-2">
                  <button
                    onClick={() => setShowDeleteModal(false)}
                    className={btn.ghost}
                  >
                    Anuluj
                  </button>

                  <button
                    onClick={() => confirmDelete(deleteId)}
                    className={btn.danger}
                  >
                    Usuń
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}